module.exports = __webpack_public_path__ + "static/media/clock.8a815a1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/clock.mp3
// module id = gady
// module chunks = 9